export const inbox = [
    {
        content:
            "Your inbox can be accessed by clicking this icon. It contains all DMs, Chat messages and Comments under posts - use it to get a quick summary of your community’s activity across all the workspace.",
        target: ".utility-nav-inbox",
        placement: "left",
    },
];
